import { jsx as l } from "react/jsx-runtime";
import { c as s } from "../clsx-OuTLNxxd.js";
import { T as d, h as m, g as _, a as p, d as T, c as i, e as C } from "../Table-BJzvuSeE.js";
import { T as w } from "../TableScrollContainer-BEvWoLR_.js";
import '../StatsTable.css';const y = "_wrapper_140pa_32", h = "_table_140pa_54", u = "_tableHead_140pa_62", N = "_tableColumn_140pa_70", S = "_tableBody_140pa_84", B = "_tableRow_140pa_88", F = "_tableCell_140pa_91", H = "_tableFooter_140pa_101", o = {
  wrapper: y,
  table: h,
  tableHead: u,
  tableColumn: N,
  tableBody: S,
  tableRow: B,
  tableCell: F,
  tableFooter: H
}, c = ({
  caption: e,
  cellWidth: t = 60,
  children: a,
  className: n,
  maxRows: b,
  ...r
}) => /* @__PURE__ */ l(
  w,
  {
    caption: e,
    cellWidth: t,
    className: s(o.wrapper, n),
    "data-cxy-name": "stats-table",
    maxRows: b,
    ...r,
    children: /* @__PURE__ */ l(d, { className: o.table, "data-testid": "stats-table", children: a })
  }
), R = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(m, { className: s(o.tableRow, t), size: "s", ...a, children: e }), g = ({
  children: e,
  className: t,
  justifyContent: a = "center",
  pinned: n,
  ...b
}) => /* @__PURE__ */ l(
  T,
  {
    className: s(o.tableColumn, t),
    "data-justify": a,
    "data-pinned": n,
    "data-type": "heading",
    justifyContent: a,
    ...b,
    children: e
  }
), f = ({
  children: e,
  className: t,
  justifyContent: a = "center",
  pinned: n,
  ...b
}) => /* @__PURE__ */ l(
  i,
  {
    className: s(o.tableCell, t),
    "data-highlight": !!b.highlight,
    "data-justify": a,
    "data-pinned": n,
    justifyContent: a,
    ...b,
    children: e
  }
), x = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(C, { ...a, className: s(o.tableFooter, t), children: e }), j = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(_, { ...a, className: s(o.tableHead, t), children: e }), z = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(p, { className: s(o.tableBody, t), ...a, children: e });
c.Row = R;
c.Head = j;
c.Body = z;
c.Column = g;
c.Cell = f;
c.Footer = x;
export {
  c as StatsTable
};
